module.exports = __webpack_public_path__ + "img/fd_icon.e0a7193f.svg";